import { FeeLevelType } from '../../types/index';
import { addFeeLevel } from "actions/Utilities/FeeLevel";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useAddFeeLevel = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (feeLevelNewData: FeeLevelType) => addFeeLevel(feeLevelNewData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetFeeLevels"]);
        toast.fire("Success", "Fee Level Added Successfully", "success");
      },
      onError: () => {
        toast.fire("Failed", "Failed to Add Fee Level", "error");
      },
    }
  );

  return mutate;
};
export default useAddFeeLevel;
